import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicGet, publicRequestPost } from "../admin/api";

// The link in watchlist emails. Opening it only checks the link (mail scanners open links on their own);
// the button unsubscribes.
export default function Unsubscribe() {
  const qs = window.location.search.replace(/^\?/, "");
  const [state, setState] = useState("checking");
  useEffect(() => {
    publicGet(`/public/dev/unsubscribe?${qs}`).then(() => setState("valid")).catch(() => setState("invalid"));
  }, [qs]);
  const go = async () => {
    try { await publicRequestPost(`/public/dev/unsubscribe?${qs}`); setState("done"); } catch (_) { setState("invalid"); }
  };
  return (
    <section data-testid="unsubscribe-page" className="space-y-6">
      <h1 className="hs-display text-3xl md:text-4xl">Watchlist emails</h1>
      {state === "checking" && <p className="text-muted">Checking the link…</p>}
      {state === "valid" && (
        <div className="hs-card max-w-2xl space-y-3">
          <p>Stop emails about changes to the servers on your watchlist?</p>
          <button type="button" className="hs-btn hs-btn-primary" onClick={go} data-testid="unsubscribe-confirm">Unsubscribe</button>
        </div>
      )}
      {state === "done" && <p role="status" className="hs-card max-w-2xl" data-testid="unsubscribe-done">
        Done: you will not get watchlist emails. You can turn them back on from your <Link className="hs-link" to="/watchlist">watchlist</Link>.</p>}
      {state === "invalid" && <p role="alert" className="hs-badge hs-badge-danger">This unsubscribe link is not valid.</p>}
    </section>
  );
}
